import { LOCATION_CHANGE } from 'connected-react-router';

let previousPathname = '';

export const previousRouterPathnameMiddleware = () => (next) => (action) => {
  if (action.type === LOCATION_CHANGE) {
    const newAction = {
      ...action,
      payload: {
        ...action.payload,
        previousPathname,
      },
    };
    previousPathname = action.payload.location.pathname;
    return next(newAction);
  }
  return next(action);
};

export const preventSegmentForGuestUsersMiddleware =
  (tracker) => (store) => (next) => (action) => {
    const { user = {} } = store.getState();
    const { userDetails } = user;

    if (userDetails && !userDetails.isGuest) {
      return tracker(store)(next)(action);
    }

    return next(action);
  };
